// removed by extract-text-webpack-plugin
module.exports = {"pager":"pager__37AnK","noData":"noData__2yPDt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayLog/styles.scss
// module id = 2277
// module chunks = 1